document.addEventListener("DOMContentLoaded", function () {
  // THROTTLE FUNCTION
  function throttle(func, wait) {
    let isThrottling = false;

    return function () {
      const context = this;
      const args = arguments;

      // If not already throttling, execute and block
      if (!isThrottling) {
        func.apply(context, args);
        isThrottling = true;

        // After the wait period, allow another execution
        setTimeout(() => {
          isThrottling = false;
        }, wait);
      }
      // If already throttling, completely ignore the call
    };
  }

  //HOVER FUNCTION
  function handleMenuItemMouseEnter(event) {
    const hoveredItem = event.target;
    const activeItem = document.querySelector(
      ".category-item.active, .subcategory-item.active"
    );

    // If hovering the active item, set its opacity to 1
    if (activeItem && activeItem === hoveredItem) {
      hoveredItem.style.opacity = "1";
    } else {
      // Set hovered item opacity to 0.4
      hoveredItem.style.opacity = "0.4";
      // Set active item back to 1
      if (activeItem) {
        activeItem.style.opacity = "1";
      }
    }
  }

  function handleMenuItemMouseLeave(event) {
    const hoveredItem = event.target;
    const activeItem = document.querySelector(
      ".category-item.active, .subcategory-item.active"
    );

    if (activeItem && activeItem === hoveredItem) {
      hoveredItem.style.opacity = "0.4";
    } else if (activeItem) {
      activeItem.style.opacity = "0.4";
    }

    // Reset non-active items to full opacity
    if (!hoveredItem.classList.contains("active")) {
      hoveredItem.style.opacity = "1";
    }
  }

  //MAIN CATEGORY EXPAND
  const categoryWrappers = document.querySelectorAll(".category-wrapper");

  function resetCategoryAnimation(wrapper) {
    // Reset title container position
    const titleContainer = wrapper.querySelector(".category-title-container");
    titleContainer.style.transform = "translateX(0)";
    titleContainer.style.removeProperty("right");

    // Reset regular category items
    const items = wrapper.querySelectorAll(
      ".category-item:not(.menu-list-items .category-item)"
    );
    items.forEach((item) => {
      item.classList.remove("visible");
      item.style.removeProperty("opacity");
    });

    // Reset submenu headers and their states
    const submenuHeaders = wrapper.querySelectorAll(
      ".submenu-header-container"
    );
    submenuHeaders.forEach((header) => {
      header.classList.remove("visible");
      header.style.removeProperty("opacity");

      // Reset expand icons
      const expandContainer = header.querySelector(".submenu-expand-container");
      const expandPlus = expandContainer?.querySelector(".submenu-expand-plus");
      const expandMinus = expandContainer?.querySelector(
        ".submenu-expand-minus"
      );
      if (expandPlus) expandPlus.style.display = "block";
      if (expandMinus) expandMinus.style.display = "none";
    });

    // Reset menu lists and their items
    const menuLists = wrapper.querySelectorAll(".menu-list-items");
    menuLists.forEach((menu) => {
      menu.style.display = "none";
      menu.classList.remove("visible");

      // Reset all subcategory items
      const subItems = menu.querySelectorAll(".category-item");
      subItems.forEach((item) => {
        item.classList.remove("visible");
        item.style.removeProperty("opacity");
      });
    });

    // Force a reflow to ensure animations start fresh
    void wrapper.offsetWidth;
  }

  categoryWrappers.forEach((wrapper) => {
    const titleContainer = wrapper.querySelector(".category-title-container");
    const headerContainer = wrapper.querySelector(".category-header-container");
    const mainExpandContainer = wrapper.querySelector(
      ".category-expand-container"
    );
    const mainPlus = mainExpandContainer?.querySelector(".menu-expand-plus");
    const mainMinus = mainExpandContainer?.querySelector(".menu-expand-minus");

    // Check if this category has active items
    const hasActiveItems = wrapper.querySelector(
      ".category-item.active, .subcategory-item.active"
    );

    // Only trigger expand/collapse when clicking the header container
    headerContainer.addEventListener(
      "click",
      throttle(function () {
        if (!wrapper.classList.contains("expanded")) {
          resetCategoryAnimation(wrapper);

          // Set main expand icons for expand state
          if (mainPlus) mainPlus.style.display = "none";
          if (mainMinus) mainMinus.style.display = "block";

          // Set right position first (ensures animation start point)
          titleContainer.style.right = "25px";
          titleContainer.style.transform = "none";
          titleContainer.style.transition = "none";

          // Force reflow
          void wrapper.offsetWidth;

          // Add expanded class
          wrapper.classList.add("expanded");

          // Request animation frame to ensure DOM updates first
          requestAnimationFrame(() => {
            // Force another reflow to ensure all styles are applied
            void wrapper.offsetWidth;

            // Get measurements after class change and DOM update
            const wrapperRect = wrapper.getBoundingClientRect();
            const titleRect = titleContainer.getBoundingClientRect();
            const distanceToMove = titleRect.left - wrapperRect.left;

            // Apply transform with animation
            titleContainer.style.transition = "transform 0.175s ease-out";
            titleContainer.style.transform = `translateX(-${distanceToMove}px)`;
          });

          // Get all animated elements in DOM order so they animate sequentially
          const allAnimatableElements = [];

          // Get direct children of the wrapper in their DOM order
          const wrapperChildren = Array.from(wrapper.children);
          wrapperChildren.forEach((child) => {
            // Handle regular category items
            if (
              child.classList.contains("category-item") &&
              !child.closest(".menu-list-items")
            ) {
              allAnimatableElements.push([child]);
            }
            // Handle submenu headers
            else if (child.classList.contains("submenu-header-container")) {
              // Push the submenu header by itself for individual animation
              allAnimatableElements.push([child]);

              // Check for active items in the corresponding menu list
              const menuList = child.nextElementSibling;
              if (menuList?.classList.contains("menu-list-items")) {
                const hasActiveItem = menuList.querySelector(
                  ".subcategory-item.active"
                );

                if (hasActiveItem) {
                  // Set up menu list for animation
                  menuList.style.display = "flex";

                  // Update expand icons
                  const submenuExpand = child.querySelector(
                    ".submenu-expand-container"
                  );
                  const submenuPlus = submenuExpand?.querySelector(
                    ".submenu-expand-plus"
                  );
                  const submenuMinus = submenuExpand?.querySelector(
                    ".submenu-expand-minus"
                  );

                  if (submenuPlus) submenuPlus.style.display = "none";
                  if (submenuMinus) submenuMinus.style.display = "block";

                  // Add menu list as its own animation step
                  allAnimatableElements.push([menuList]);
                }
              }
            }
          });

          // Update your animation loop to handle all types consistently
          allAnimatableElements.forEach((group, index) => {
            setTimeout(() => {
              group.forEach((item) => {
                void item.offsetHeight;
                item.classList.add("visible");

                // If this is a menu list, make its items visible
                if (item.classList.contains("menu-list-items")) {
                  const subItems = item.querySelectorAll(".category-item");
                  subItems.forEach((subItem) => {
                    subItem.classList.add("visible");
                  });
                }
              });
            }, 125 * (index + 1));
          });
          // After all animations are set, initialize the gradient
          setTimeout(() => {
            if (typeof window.initializeMenuGradient === "function") {
              window.initializeMenuGradient({ withTransition: true });
            }
          }, 125 * (allAnimatableElements.length + 1));
        } else {
          // Collapse - resets the animation
          wrapper.classList.remove("expanded");

          // Set main expand icons for collapse state
          if (mainPlus) mainPlus.style.display = "block";
          if (mainMinus) mainMinus.style.display = "none";

          // Reset positioning to original values with animation
          titleContainer.style.transition = "transform 0.175s ease-out";
          titleContainer.style.transform = "translateX(0)";
          titleContainer.style.right = "25px";

          resetCategoryAnimation(wrapper);

          setTimeout(() => {
            if (typeof window.initializeMenuGradient === "function") {
              window.initializeMenuGradient({ withTransition: true });
            }
          }, 200);
        }
      }, 200)
    );
  });

  // Handle submenu interactions
  const localSubmenuHeaders = document.querySelectorAll(
    ".submenu-header-container"
  );

  localSubmenuHeaders.forEach((submenu) => {
    const expandContainer = submenu.querySelector(".submenu-expand-container");
    const expandPlus = expandContainer?.querySelector(".submenu-expand-plus");
    const expandMinus = expandContainer?.querySelector(".submenu-expand-minus");

    // Get the menu list items container that follows this header
    const menuListItems = submenu.nextElementSibling;

    // Initialize animation state as not running
    submenu.addEventListener("click", function (e) {
      e.stopPropagation();

      const isVisible =
        window.getComputedStyle(menuListItems).display !== "none";

      if (isVisible) {
        menuListItems.style.display = "none";

        if (expandPlus && expandMinus) {
          expandPlus.style.display = "block";
          expandMinus.style.display = "none";
        }

        setTimeout(() => {
          if (typeof window.initializeMenuGradient === "function") {
            window.initializeMenuGradient({ withTransition: true });
          }
        }, 100);
      } else {
        menuListItems.style.display = "flex";

        if (expandPlus && expandMinus) {
          expandPlus.style.display = "none";
          expandMinus.style.display = "block";
        }

        const subItems = menuListItems.querySelectorAll(".category-item");
        subItems.forEach((item) => {
          item.classList.add("visible");
        });

        // Check gradient after items are visible
        setTimeout(() => {
          if (typeof window.initializeMenuGradient === "function") {
            window.initializeMenuGradient({ withTransition: true });
          }
        }, 100);
      }
    });
  });
  //HOVER STATE FOR CLICKABLE MENU ITEMS
  const menuItems = document.querySelectorAll(
    ".category-item, .subcategory-item"
  );
  menuItems.forEach((item) => {
    item.addEventListener("mouseenter", handleMenuItemMouseEnter);
    item.addEventListener("mouseleave", handleMenuItemMouseLeave);

    // Set cursor to default if item is active
    if (item.classList.contains("active")) {
      item.style.cursor = "default";
    }
  });
});
